export default __webpack_public_path__ + "static/media/exhaust_air_fan.c3557055.png";